module.exports = __webpack_public_path__ + "img/hero.7efd54fa.gif";